import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

bootstrapApplication(AppComponent, appConfig).catch(err => {
  logNg0201Diagnostics(err);
  console.error(err);
});

/** Production bundles omit "No provider for …" text for NG0201; dependency path lives on ownKeys. */
function logNg0201Diagnostics(err: unknown): void {
  if (!err || typeof err !== 'object') return;
  const e = err as Record<PropertyKey, unknown> & { code?: number; message?: unknown };
  const msg = String(e.message ?? '');
  if (e.code !== -201 && !msg.includes('NG0201')) return;
  console.error(
    '[NG0201] Angular production hides the missing token in message; inspect ownKeys below for ngTokenPath / ngErrorMessage.',
  );
  for (const key of Reflect.ownKeys(e)) {
    console.error(`  ${String(key)}:`, e[key]);
  }
}
